<template lang="pug">
  div.analise(v-if="cadastro && cadastro.json")
    div.rowVoltar
      el-button(type="success", @click="voltar", :disabled="active === 0").btnVoltar
        i.fa.fa-chevron-left
      h2 Cadastro de Regularização Fundiária
    el-steps(:active='active', finish-status='success', simple)
      el-step(
        v-for="(step, index) in steps"
        :key="index"
        :title="step.title"
        :finish-status="index < active ? 'success' : (index === active ? 'process' : 'wait')"
      )
    div.content
      div(v-if="active === 0")
        el-card(shadow="hover").card-collapse
          app-formulario-dados-gerais(
            :jsonCadastro="cadastro.json"
            ref="dadosGerais"
          )
      div(v-if="active === 1")
        el-card(shadow="hover").card-collapse
          app-formulario-outorgante(
            :jsonCadastro="cadastro.json"
            ref="outorgante"
          )
      div(v-if="active === 2")
        el-card(shadow="hover").card-collapse
          app-formulario-imovel(
            :jsonCadastro="cadastro.json"
            ref="imovel"
          )
      div(v-if="active === 3")
        el-card(shadow="hover").card-collapse
          app-formulario-avaliacao-imovel(
            :jsonCadastro="cadastro.json"
            ref="avaliacaoImovel"
          )
    app-buttons-cadastro(
      :isUltimoPasso="active === steps.length - 1",
      :showButtonProximo="active < steps.length - 1",
      :showButtonVoltar="false"
      :showButtonFinalizar="active === 3"
      :showButtonSalvar="true"
      @salvar="salvarCadastro"
      @finalizar="finalizarCadastro",
      @proximo="proximo",
      @cancelar="cancelar",
    )
</template>
<script>
import { mapActions } from 'vuex'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppFormularioDadosGerais from './cadastroRf/AppFormularioDadosGerais.vue'
import AppFormularioOutorgante from './cadastroRf/AppFormularioOutorgante.vue'
import AppFormularioImovel from './cadastroRf/AppFormularioImovel.vue'
import AppFormularioAvaliacaoImovel from './cadastroRf/AppFormularioAvaliacaoImovel.vue'
import { cloneDeep } from 'lodash'

export default {
  components: {
    AppButtonsCadastro,
    AppFormularioDadosGerais,
    AppFormularioOutorgante,
    AppFormularioImovel,
    AppFormularioAvaliacaoImovel
  },

  mixins: [AppNotificacao],

  data () {
    return {
      active: 0,
      cadastro: {json: null},
      steps: [
        {title: 'Dados gerais', ref: 'dadosGerais'},
        {title: 'Cadastro outorgante', ref: 'outorgante'},
        {title: 'Cadastro do imóvel', ref: 'imovel'},
        {title: 'Informações de avaliação do imóvel', ref: 'avaliacaoImovel'}
      ]
    }
  },
  methods: {
    ...mapActions({
      finalizarCadastroRf: 'cadastroRf/finalizarCadastroRf',
      salvarCadastroRf: 'cadastroRf/salvarCadastroRf',
      cadastroRfById: 'cadastroRf/cadastroRfById'
    }),
    async proximo () {
      if (this.active < this.steps.length - 1) {
        if (await this.isValidCampos()) {
          try {
            await this.salvarCadastro()
            this.active++
          } catch (_) {}
        }
      }
    },
    async isValidCampos () {
      const isValid = await this.$refs[this.steps[this.active].ref].validate()
      if (!isValid) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.PREENCHA_TODOS_CAMPOS
        )
      }
      return isValid
    },
    async voltar () {
      if (this.active > 0) {
        await this.salvarCadastro()
        this.active--
      }
    },
    async finalizarCadastro () {
      try {
        if (await this.isValidCampos()) {
          this.confirmBox(
            this.$messages.MSG_CONFIRMACAO,
            this.$messages.TITULO_WARNING,
            async () => {
              const cadastro = cloneDeep(this.cadastro.json)
              cadastro.interessado.pessoa.telefones = this.formatNumTelefoneJson(cadastro.interessado.pessoa.telefones)
              this.formatAllDocumentosJson(cadastro)
              await this.finalizarCadastroRf(cadastro)

              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                this.$messages.CADASTRO_RF_SUCESSO
              )

              this.$router.push({
                name: 'CADASTROS_EM_ANDAMENTO_RF'
              })
            }
          )
        }
      } catch (e) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          this.$messages.CADASTRO_RF_ERRO
        )
      }
    },
    async salvarCadastro () {
      try {
        let cadastro = cloneDeep(this.cadastro.json)
        cadastro.interessado.pessoa.telefones = this.formatNumTelefoneJson(cadastro.interessado.pessoa.telefones)
        this.formatAllDocumentosJson(cadastro)
        cadastro = await this.salvarCadastroRf(cadastro)
        this.formatAllDocumentosAnalise(cadastro)
        cadastro.interessado.pessoa.telefones = this.formatNumTelefoneAnalise(cadastro.interessado.pessoa.telefones)
        if (cadastro.georreferenciamento.localizacoes) {
          cadastro.georreferenciamento.localizacoes = cadastro.georreferenciamento.localizacoes.map(l => {
            return {
              geometry: JSON.parse(l.geometry)
            }
          })
        }
        this.cadastro.json = cadastro
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.$messages.CADASTRO_RF_SALVO_SUCESSO
        )
      } catch (e) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          this.$messages.CADASTRO_RF_ERRO
        )
      }
    },
    cancelar () {
      this.confirmBox(
        `Tem certeza que deseja cancelar? Seus dados não serão salvos`,
        this.$messages.TITULO_WARNING,
        () => {
          this.$router.back()
        },
        () => {}
      )
    },
    formatAllDocumentosJson (json) {
      json.interessado.documentos = json.interessado.documentos.map(d => this.formataDocumentoJson(d))
      json.imovel.documentos = json.imovel.documentos.map(d => this.formataDocumentoJson(d))
      json.avaliacaoImovel.documentosLaudo = json.avaliacaoImovel.documentosLaudo.map(d => this.formataDocumentoJson(d))
      json.georreferenciamento.documentos = json.georreferenciamento.documentos.map(d => this.formataDocumentoJson(d))
    },
    formatAllDocumentosAnalise (json) {
      json.interessado.documentos = json.interessado.documentos.map(d => this.formataDocumentoAnalise(d))
      json.imovel.documentos = json.imovel.documentos.map(d => this.formataDocumentoAnalise(d))
      json.avaliacaoImovel.documentosLaudo = json.avaliacaoImovel.documentosLaudo.map(d => this.formataDocumentoAnalise(d))
      json.georreferenciamento.documentos = json.georreferenciamento.documentos.map(d => this.formataDocumentoAnalise(d))
    },
    formataDocumentoAnalise (documento) {
      return {
        id: documento.id,
        fileKey: documento.fileKey || documento.key,
        fileName: documento.fileName || documento.nome,
        caminho: documento.caminho,
        tipoDocumento: {
          codigo: documento.tipo.codigo,
          id: documento.tipo.id,
          descricao: documento.tipo.descricao,
          tipo: documento.tipo.codigo
        }
      }
    },
    formataDocumentoJson (documento) {
      return {
        id: documento.id,
        caminho: documento.caminho,
        key: documento.fileKey || documento.key,
        nome: documento.fileName || documento.nome,
        fileName: documento.fileName || documento.nome,
        tipo: documento.tipoDocumento || documento.tipo,
        fileKey: documento.fileKey || documento.key,
        tipoDocumento: documento.tipoDocumento || documento.tipo
      }
    },
    formatNumTelefoneAnalise (telefones) {
      return telefones.map(num => num.numero)
    },
    formatNumTelefoneJson (telefones) {
      return telefones.map(num => { return {numero: num} })
    }
  },
  async created () {
    this.cadastro.json = await this.cadastroRfById(this.$route.params.id)
    this.cadastro.json.cadastroRf.id = this.$route.params.id
    this.formatAllDocumentosAnalise(this.cadastro.json)
    this.cadastro.json.interessado.pessoa.telefones = this.formatNumTelefoneAnalise(this.cadastro.json.interessado.pessoa.telefones)
    if (this.cadastro.json.georreferenciamento.localizacoes) {
      this.cadastro.json.georreferenciamento.localizacoes = this.cadastro.json.georreferenciamento.localizacoes.map(l => {
        return {
          geometry: JSON.parse(l.geometry)
        }
      })
    }
  }
}

</script>
<style lang="scss">
  .card-collapse {
    border-radius: 10px;
    margin: 10px 0;
  }
  .analise {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .rowVoltar {
    display: flex;
    height: 50px;
    gap: 20px;
    align-items: center;
    margin-bottom: 20px;
  }
  .btnVoltar {
    height: 30px;
    width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppCadastroRf.vue